var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71491 8.46664L7.86806 6.93559L1.4247 13.5316H17.8414L11.5166 6.92445L9.71491 8.46664ZM12.4384 6.22437L18.566 12.5953C18.601 12.4717 18.6261 12.3436 18.6261 12.2082V1.19622L12.4384 6.22437ZM0.803711 1.17061V12.2082C0.803711 12.3436 0.828775 12.4717 0.863862 12.5953L7.01203 6.24497L0.803711 1.17061ZM18.0692 0.15918H1.36066L9.71491 6.85317L18.0692 0.15918Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.00a198f5a9499fed232fd372fdc5a894.svg";
export { ForwardRef as ReactComponent };